import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../../app/hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/dashboard/recent' // (7) 최근 입금 내역

let swrData: any = getPersistData(KEY)

export function useCurrentDeposit() {
	const { data: token } = useToken()
	const { data, mutate } = useSWR<any>(
		KEY,
		async () => {
			const response = await API.get(KEY, token + '', {})
			swrData = response.result?.result?.list

			return swrData
		},
		{ revalidateOnFocus: true }
	)

	return {
    currentDepositData: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrData = value
			}
			return mutate()
		},
	}
}